/**
 * © [2025] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import axios from 'axios';
import _ from 'lodash';
import * as actionTypes from './ActionTypes';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import { arrayMove } from '../../../../SharedModules/CommonUtilities/commonUtilities';

export const handleErrorMessagesNicheReport = (data) => ({
  type: actionTypes.HANDLE_ERROR_MESSAGE_RDNR,
  errorMessagesInRedux: data,
});

export const getPlanTypeRadioBoxValue = () => {
  return axios
    .post(serviceEndPoint.GET_COMMON_MANUFACUTRE_DROPDOWNS, {
      codeDomainList: ['PLAN_TYPE_CD'],
    })
    .then((response) => {
      const tempObj = response.data;
      let updatedArray = [];
      if (tempObj?.PLAN_TYPE_CD?.length > 0) {
        const planArray = tempObj?.PLAN_TYPE_CD;
        planArray.map((element) => {
          if (element?.codeValueID?.codeValue === 'FD') {
            const indexOf = _.findIndex(planArray, element);
            if (!_.isNull(indexOf) && indexOf >= 0) {
              updatedArray = arrayMove(tempObj?.PLAN_TYPE_CD, indexOf, 0);
            }
          }
          return element;
        });
      }
      return updatedArray;
    })
    .catch(() => {
      return [];
    });
};
export const setDataNicheReportScreenTab = (data) => {
  return {
    type: actionTypes.DATA_NICHE_REPORT_SCREEN_TAB_DATA,
    dataNicheReportScreenObj: data,
  };
};
export const getRebateProgramDropdownList = (value) => {
  return axios
    .post(`${serviceEndPoint.SYSTEM_LIST_ALL_DROPDOWN}`, { planType: value })
    .then((response) => {
      return response?.data;
    })
    .catch(() => {
      return [];
    });
};
export const getNicheRptAvailableMsg = (value) => {
  return axios
    .post(`${serviceEndPoint.GET_NICHE_REPORT_AVAILABLE}`, value)
    .then((response) => {
      return response?.data;
    })
    .catch(() => {
      return [];
    });
};
export const getGenerateNicheReport = (value) => {
  return axios
    .post(`${serviceEndPoint.GET_GENERATE_NICHE_REPORT}`, value)
    .then((response) => {
      return response?.data;
    })
    .catch(() => {
      return [];
    });
};
export const clearReduxReqDataNicheReportScreen = () => (dispatch) => {
  dispatch(handleErrorMessagesNicheReport([]));
  dispatch(setDataNicheReportScreenTab({}));
};
